
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'

import bus from '@/javascript/bus'

export default {
directives: {
TransferDom
},
components: {
Cpts020,
Tab,
TabItem,
Actionsheet,
Confirm,
Toast
},
data() {
return {
minHeight: '',
tabItems: [],
tabIndex: 0,
isTop: false,
Whether: false,
operateWay: {
save: '保存',
noSave: '不保存'
},
more: false,
cornerMark: false,
dayList: {},
chooseWay: false,
adjustWay: {
travelDates: '出行日期和出发地',
ways: '出行方式',
spotGroup: '景点组合'
},
leftLayer: false,
rightLayer: true,
tripLine: [], //行程路线
spotList: [], //旅行地图
route: [], //行程概览
usedTime: [],
tripMode: true,
travelId: [], //行程id
startCityCode: '', //出发城市编码
startCityName: '', //车发城市名称
endCityCode: '', //返回城市编码
startCityName: '', //返回城市名称
transportType: '', //出行方式
visitorType: '', //游客类型
tags: [], //出游意向
planDays: '',//出游天数
scenicIds: [], //景点id
scenicSpots: [], //景点
senId: '',
userId: bus.userInfo.user.id,
saveShow: false,
params: '',
statusShow: false,
nowId: '',
status: '', //保存状态
saveId: '',
condition: false,
routeLine: [],
others: true,
createId: '', //行程创建者id
prevId: [],
prompt: false,
saveFailed: '保存失败,请稍后再试',
planStartDate: '' 
};
},
created() {
this.senId = this.$route.params.id
this.tabItems = [{
name: '概要',
routerLink: '/travel-profile/'
}, {
name: '详情',
routerLink: '/travel-details/0/'
}, {
name: '地图',
routerLink: '/map-days/'
},




]

this.showPoint()

},
mounted() {
this.minHeight = document.documentElement.clientHeight;

/**
* 页面滚动
*/
window.addEventListener('scroll', this.windowScroll)


},
methods: {
windowScroll: function () {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

if (this.$refs.top && scrollTop >= this.$refs.top.offsetTop) {
this.isTop = true
} else {
this.isTop = false
}
},
tabHandler: function (index) {
this.$router.replace({path: this.tabItems[index].routerLink + this.senId})
},
showPoint: function () {
this.$http.get('api/wtcp-recommend/public/travelPlan/app/' + this.senId + '/' + this.userId ).then((response) => {
if(response.data.data){
this.$set(this,'dayList',response.data.data)

this.nowId = this.dayList.id
this.startCityCode = this.dayList.startCityCode
let chufachengshi = this.dayList.startCityName.split("|")
if(chufachengshi[chufachengshi.length - 1] == "市辖区"){
this.startCityName = chufachengshi[chufachengshi.length - 2];
}else{
this.startCityName = chufachengshi[chufachengshi.length - 1];
}
this.endCityCode = this.dayList.endCityCode
let jieshuchengshi = this.dayList.endCityName.split("|")
if(jieshuchengshi[jieshuchengshi.length - 1] == "市辖区"){
this.endCityName = jieshuchengshi[jieshuchengshi.length - 2];
}else{
this.endCityName = jieshuchengshi[jieshuchengshi.length - 1];
}


this.transportType = this.dayList.transportType
if (this.transportType == 1) {
this.tripMode = false
}
this.visitorType = this.dayList.visitorType


this.tags = this.dayList.tags.split(',')


this.planDays = this.dayList.planDays


this.scenicIds = this.dayList.scenicIds.split(',')
this.scenicSpots = this.dayList.planDetail.scenicSpots
this.scenicSpots.map( item => {
let stateName = item.areaName.split(',')[1]
this.$set(item, 'stateName', stateName)
})


this.status = this.dayList.status

if(this.status == 0){
this.statusShow = true
this.params = JSON.parse(sessionStorage.getItem('historyData'))
this.saveId = JSON.parse(sessionStorage.getItem('historyData')).travelId ? JSON.parse(sessionStorage.getItem('historyData')).travelId : []
this.quoteId = JSON.parse(sessionStorage.getItem('historyData')).createId ? JSON.parse(sessionStorage.getItem('historyData')).createId : ''
this.prevId = JSON.parse(sessionStorage.getItem('historyData')).prevCreateId ? JSON.parse(sessionStorage.getItem('historyData')).prevCreateId : []
}


this.createId = this.dayList.createdUserId
if( this.status === 2 && this.createId !== this.userId){
this.others = false
}


this.planStartDate = this.dayList.planStartDate
}

}).then(() => {
document.title = this.dayList.title
/* 行程路线 */
this.tripLine = this.dayList.planDetail.cityList;

/* 获取行程路行模块高度,判断是否显示下拉角标 */
this.$nextTick(function () {
const travelLine = this.$refs.lineHeight.offsetHeight;
if (travelLine > 70) {
this.cornerMark = true
}
})

/* 行程概览 */
this.route = this.dayList.planDetail.dailyPlans

for(let i = 0; i < this.route.length; i++){
if(this.route[i].dailySteps[0].startAddress == this.route[i].dailySteps[0].endAddress){
this.$set(this.route[i], 'repeatData', false)
}else{
this.$set(this.route[i], 'repeatData', true)
}
}

let dayData = this.route
for (let n = 0; n < dayData.length; n++) {
for (let i = 0; i < dayData[n].dailySteps.length - 1; i++) {
if (dayData[n].dailySteps[i].endAddress == dayData[n].dailySteps[i + 1].endAddress) {
this.$set(dayData[n].dailySteps[i], 'endAddress', dayData[n].dailySteps[i + 1].endAddress);
this.$set(dayData[n].dailySteps[i], 'stepType', dayData[n].dailySteps[i + 1].stepType);
dayData[n].dailySteps.splice(i + 1, 1)
}
}
}
this.$set(this, 'route', dayData)

/* 计算时间 */
this.route.map(item => {
let busTime = [] 
let airTime = [] 
let trainTime = [] 
let driveTime = [] 
let spotTime = []  
item.dailySteps.map(pice => {
let timeH = (pice.useTime / 3600).toFixed(1)
if (timeH == 0.0) {
timeH = 0.1
}
this.$set(pice, 'timeH', timeH)
switch (pice.stepType) {
case 1: //租车/包车/出租车
busTime.push(Number(pice.timeH))
break;
case 3: //飞机
airTime.push(Number(pice.timeH))
break;
case 4: //火车
trainTime.push(Number(pice.timeH))
break;
case 5: //自驾
busTime.push(Number(pice.timeH))
break;
case 9:  //景区
spotTime.push(Number(pice.timeH))
break;
default:
break;
}
})
let allWay = busTime.concat(airTime).concat(trainTime)

if (allWay.length !== 0) {
let allTime1 = allWay.reduce(function (prev, next, index, array) {
return prev + next;
})
let allTime = (allTime1).toFixed(1)
this.$set(item, 'allTime', allTime)
}

if (airTime.length !== 0) {
let flyTime1 = airTime.reduce(function (prev, next, index, array) {
return prev + next;
})
let flyTime = (flyTime1).toFixed(1)
this.$set(item, 'flyTime', flyTime)
}

if (busTime.length !== 0) {
let cityTime1 = busTime.reduce(function (prev, next, index, array) {
return prev + next;
})
let cityTime = (cityTime1).toFixed(1)
this.$set(item, 'cityTime', cityTime)
}

if (trainTime.length !== 0) {
let ironTime1 = trainTime.reduce(function (prev, next, index, array) {
return prev + next;
})
let ironTime = (ironTime1).toFixed(1)
this.$set(item, 'ironTime', ironTime)
}

if (spotTime.length !== 0) {
let playTime1 = spotTime.reduce(function (prev, next, index, array) {
return prev + next;
})
let playTime = (playTime1).toFixed(1)
this.$set(item, 'playTime', playTime)
}

})

/* 旅行地图 */
this.spotList = this.dayList.planDetail.scenicSpots.map(item => {
return {
name: item.name,
longitude: item.longitude,
latitude: item.latitude
}
})

if (this.spotList.length > 0) {
const map_1 = new AMap.Map('travel_map', {
resizeEnable: true,
zoomEnable: false,
dragEnable: false,
zoom: 4,
center: [this.spotList[0].longitude, this.spotList[0].latitude]
});

const markers = []

this.spotList.forEach(marker => {
const data = {
icon: require('../../../../assets/sci_map.png'),
name: marker.name,
position: [marker.longitude, marker.latitude]
}
markers.push(data)
});
markers.forEach(marker => {
new AMap.Text({
map: map_1,
text: '<div class="dl-marker">' +
'<span><img src="' + marker.icon + '" /></span>' +
'<p>' + marker.name + '</p>' +
'</div>',
position: [marker.position[0], marker.position[1]],
});
});

}
return this.spotList
})
},
modifyData: function () {
this.travelId = [{
nowId:this.nowId,
status:this.status
}]
let newId = []
if(this.saveId == ''){
newId = this.travelId
}else{
let idList = this.saveId.concat(this.travelId)

for(var i=0;i<idList.length;i++){
var flag = true;
for(var j=0;j<newId.length;j++){
if(idList[i].nowId == newId[j].nowId){
flag = false;
};
};
if(flag){
newId.push(idList[i]);
};
};
}
let arrCreateId = this.prevId.concat([this.createId])
const params = {
createId: this.createId,
prevCreateId: arrCreateId,
travelId: newId ,
startCityCode: this.startCityCode,
startCityName: this.startCityName,
endCityCode: this.endCityCode,
endCityName: this.endCityName,
transportType: this.transportType,
visitorType: this.visitorType,
tags: this.tags,
planDays: parseInt(this.planDays),
scenicIds: this.scenicIds,
scenicSpots: this.scenicSpots,
planStartDate: this.planStartDate
}
sessionStorage.setItem('historyData', JSON.stringify(params))
},
modifyTtrip: function () {
if(this.others){
this.chooseWay = true
}else{
this.modifyData()
this.$router.push({path: '/travel-choice'})
}
},
showLine: function () {
this.more = !this.more
},
modifyWay: function (key) {
this.modifyData()
switch (key) {
case 'travelDates':
this.$router.push({path: '/travel-choice'})
break;
case 'ways':
this.$router.push({path: '/travel-preference'})
break;
case 'spotGroup':
this.$router.push({path: '/choose-spot'})
break;
default:
break
}
},
goMap: function () {
this.$router.push({path: this.tabItems[2].routerLink + this.senId})
},
goDetails: function () {
this.$router.push({path: this.tabItems[1].routerLink + this.senId})
},
saveTrip: function() {
this.saveShow = true
},
onConfirm () {
this.saveShow = false

let agoId = ''

this.saveId.forEach(item => {
if (item.status !== 0 && this.userId === this.prevId[0]) {
agoId = item.nowId
this.condition = true
}
})
if(this.condition && this.userId === this.quoteId){
this.$http.post('/api/wtcp-recommend/public/travelPlan/app/' + this.senId + '/' + this.userId + '/' + this.DEPT_CODE.DEPTCODE + '&oldId=' + agoId ).then((response) => {

if(response.data.msg == "success"){
this.$router.push({path: '/center'})
}else{
this.prompt = true
}
})
}else{
this.$http.post('/api/wtcp-recommend/public/travelPlan/app/' + this.senId + '/' + this.userId + '/' + this.DEPT_CODE.DEPTCODE).then((response) => {

if(response.data.msg == "success"){
this.$router.push({path: '/center'})
}else{
this.prompt = true
}
})
}
},
onCancel (){
this.saveShow = false
}
}
};
